import { render, staticRenderFns } from "./TarjetaResultadoMedico.vue?vue&type=template&id=5306f8b0"
import script from "./TarjetaResultadoMedico.vue?vue&type=script&lang=js"
export * from "./TarjetaResultadoMedico.vue?vue&type=script&lang=js"
import style0 from "./TarjetaResultadoMedico.vue?vue&type=style&index=0&id=5306f8b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports